const newQueryFormFields = {
  computed: {
    /**
     * The shared fields.
     *
     * @returns {Array}
     */
    sharedFields() {
      return [];
    },

    /**
     * The exclusives fields grouped.
     *
     * @returns {Array}
     */
    exclusiveFieldsGrouped() {
      return [this.form.consultation]
        .reduce((groups, consultation) => {
          if (!consultation.fields) {
            return groups;
          }

          const exclusiveFields = consultation
            .fields
            .filter(({ name, type }) => name.includes('/') && (type === 'select' || type === 'radio'));

          if (exclusiveFields.length === 0) {
            return groups;
          }

          groups.push({
            name: consultation.name,
            label: consultation.label,
            fields: exclusiveFields,
          });

          return groups;
        }, []);
    },
  },
};

export default newQueryFormFields;
